import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';
import { ASSESSMENT_PATH } from '@/features/assessment/paths';
import AssessmentPage from '@/pages/AssessmentPage';
import OnboardingChatPage from '@/pages/OnboardingChatPage';

const router = createBrowserRouter([
  { path: '/', element: <Navigate to="/onboarding" replace /> },
  { path: '/onboarding', element: <OnboardingChatPage /> },
  { path: ASSESSMENT_PATH, element: <AssessmentPage /> },
  { path: '*', element: <Navigate to="/onboarding" replace /> },
]);

export default function App() {
  return <RouterProvider router={router} />;
}
